// extracted by mini-css-extract-plugin
module.exports = {"custom-file-input":"List_custom-file-input__1y8yg","closeModalBtn":"List_closeModalBtn__xFOD6"};